import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';

import { Logger, skipUndefined } from 'thkee-common';
import { AuthenticationService } from './authentication.service';

const log = new Logger('AuthenticationGuard');

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard {
  constructor(private router: Router, private store: Store, private authService: AuthenticationService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.authService.sessionExist().pipe(
      skipUndefined(),
      take(1),
      map((authenticated) => {
        if (authenticated) {
          return true;
        }
        this.router.navigate(['/auth'], { queryParams: { redirect: state.url }, replaceUrl: true });
        return false;
      })
    );
  }
}
